import { render, staticRenderFns } from "./privateMessageChat.vue?vue&type=template&id=b11d14b0&scoped=true"
import script from "./privateMessageChat.vue?vue&type=script&lang=js"
export * from "./privateMessageChat.vue?vue&type=script&lang=js"
import style0 from "./privateMessageChat.vue?vue&type=style&index=0&id=b11d14b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b11d14b0",
  null
  
)

export default component.exports